import interrupt from "../interrupt";

export default function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-transition/src/selection/interrupt.js
// module id = 1237
// module chunks = 4